var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

// pageTop
import {pageTop} from "../include/module";
pageTop();

// anchorLink
import {anchorLink} from "../include/module";
anchorLink();

$(window).on('load' , function() {

  scrollCommonAnime();

});

// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ヘッダー縮める
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Keyvisual',
    triggerHook: 0,
    offset: '100'
  })
  .setClassToggle('#st-Header,#st-Header_Logo', 'short')
  // .addIndicators({name: "1"})
  .addTo(controller);
};

/* =============================================================== */
/* scroll-Message */
/* =============================================================== */
const scrollMessage = () => {
  const message = document.querySelector('.gloryfinder-Message');
  if (!message) {
    return false;
  }

  // オプション設定
  const options = {
    root: null, // ビューポートをルートに使用
    rootMargin: '0px', // ルートマージン
    threshold: 0.5 // ターゲットが100%表示されたらコールバックを実行
  };

  // コールバック関数
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-Active');
        observer.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  };

  // IntersectionObserverを作成
  const observer = new IntersectionObserver(callback, options);

  // ターゲット要素を監視
  if(0 < message.getBoundingClientRect().top){
    observer.observe(message);
  }else{
    message.classList.add('is-Active');
  }

};

/* =============================================================== */
/* scroll-Character */
/* =============================================================== */
const scrollCharacter = () => {
  const characters = document.querySelectorAll('.character-List .character-Item');
  if (!characters) {
    return false;
  }

  // オプション設定
  const options = {
    root: null, // ビューポートをルートに使用
    rootMargin: '0px', // ルートマージン
    threshold: 0.5 // ターゲットが100%表示されたらコールバックを実行
  };

  // コールバック関数
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-Active');
        observer.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  };

  // IntersectionObserverを作成
  const observer = new IntersectionObserver(callback, options);

  // ターゲット要素を監視
  characters.forEach(target => {
    if(0 < target.getBoundingClientRect().top){
      observer.observe(target);
    }else{
      target.classList.add('is-Active');
    }
  });

};

/* =============================================================== */
/* jsScroll */
/* =============================================================== */
const jsScroll = () => {
  const scrollTargets = document.querySelectorAll('.js-Scroll');
  if (!scrollTargets) {
    return false;
  }

  // オプション設定
  const options = {
    root: null, // ビューポートをルートに使用
    rootMargin: '0px 0px -200px 0px', // ルートマージン
    threshold: 0 // ターゲットが100%表示されたらコールバックを実行
  };

  // コールバック関数
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-Active');
        observer.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  };

  // IntersectionObserverを作成
  const observer = new IntersectionObserver(callback, options);

  // ターゲット要素を監視
  scrollTargets.forEach(target => {
    if(0 < target.getBoundingClientRect().top){
      observer.observe(target);
    }else{
      target.classList.add('is-Active');
    }
  });

};

/* =============================================================== */
/* jsAction */
/* =============================================================== */
const jsAction = () => {
  const actionTargets = document.querySelectorAll('.js-Action');
  if (!actionTargets) {
    return false;
  }

  // オプション設定
  const options = {
    root: null, // ビューポートをルートに使用
    rootMargin: '0px 0px -200px 0px', // ルートマージン
    threshold: 0 // ターゲットが100%表示されたらコールバックを実行
  };

  // コールバック関数
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-Active');
        observer.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  };

  // IntersectionObserverを作成
  const observer = new IntersectionObserver(callback, options);

  // ターゲット要素を監視
  actionTargets.forEach(actionTarget => {
    if(0 < actionTarget.getBoundingClientRect().top){
      observer.observe(actionTarget);
    }else{
      actionTarget.classList.add('is-Active');
    }
  });

};

window.addEventListener('load', function(){
  setTimeout(function(){
    scrollMessage();
    scrollCharacter();
    jsScroll();
    jsAction();
  },100);
});


// WEBPACK FOOTER //
// ./src/en-shadowverse-evolve/assets/js/gloryfinder/script.js